import { EScrollRegistryKeys } from './scrollRegistryKeys';

const scrollCallbacks = new Map<EScrollRegistryKeys, () => void>();

export const registerScrollCallback = (key: EScrollRegistryKeys, cb: () => void) => {
  scrollCallbacks.set(key, cb);
};

export const clearScrollCallbacks = () => {
  scrollCallbacks.clear();
};

export const triggerRegisteredScroll = (keys: EScrollRegistryKeys[]) => {
  keys.forEach((key) => {
    scrollCallbacks.get(key)?.();
  });
};
